import { connect } from 'react-redux';
import OPTCode from '../../../components/login/mfa/OPTCode';

export default connect(_ => ({}), {})(OPTCode);
